import { AbstractControl, ValidationErrors } from '@angular/forms';
import Ajv from 'ajv';
import addFormats from 'ajv-formats';

export const validAjvSchemaValidator = () => {
  return (control: AbstractControl): ValidationErrors | null => {
    let parsed: unknown;
    try {
      parsed = JSON.parse(control.value);
    } catch {
      // Not valid JSON - handled by validJsonValidator, nothing to check here.
      return null;
    }

    const schema = (parsed as { schema?: unknown })?.schema;
    if (schema === undefined || schema === null) {
      return null;
    }

    try {
      const ajv = new Ajv({ strict: true, allErrors: false });
      addFormats(ajv);
      ajv.compile(schema as object);
      return null;
    } catch (e) {
      return { invalidSchema: { value: e instanceof Error ? e.message : String(e) } };
    }
  };
};
